const PLACEMENT_TOP_START = 'top-start';
const PLACEMENT_TOP_END = 'top-end';
const PLACEMENT_BOTTOM_START = 'bottom-start';
const PLACEMENT_BOTTOM_END = 'bottom-end';
const PLACEMENT_RIGHT_START = 'right-start';
const PLACEMENT_RIGHT_END = 'right-end';
const PLACEMENT_LEFT_START = 'left-start';
const PLACEMENT_LEFT_END = 'left-end';

export { PLACEMENT_BOTTOM_END, PLACEMENT_BOTTOM_START, PLACEMENT_LEFT_END, PLACEMENT_LEFT_START, PLACEMENT_RIGHT_END, PLACEMENT_RIGHT_START, PLACEMENT_TOP_END, PLACEMENT_TOP_START };
